import React, { useState } from "react";
import FilteredConnectionsSection from "./FilteredConnectionsSection";
import {
    Connection,
    ConnectionFilterType,
    ConnectionRenderType,
    ConnectionsMeta,
} from "../../gql/types";
import { ConnectionPlacementType } from "./constants";
import styles from "./ManualListPlacementPage.module.css"; // You can define divider style here

interface ManualListPlacementPageProps {
    selectedIds: Set<string>;
    onToggle: (connectionIds: string[]) => void;
    onFetchedConnectionsChange?: (map: Record<string, Connection>) => void;
}

const ManualListPlacementPage: React.FC<ManualListPlacementPageProps> = ({
    selectedIds,
    onToggle,
    onFetchedConnectionsChange,
}) => {
    const metas: ConnectionsMeta[] = [
        {
            __typename: "ConnectionsMeta",
            filter: ConnectionFilterType.School,
            renderType: ConnectionRenderType.Family,
            initialCursor: null,
        },
        {
            __typename: "ConnectionsMeta",
            filter: ConnectionFilterType.All,
            renderType: ConnectionRenderType.Family,
            initialCursor: null,
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.sectionDivider} />
            <div className={styles.innerContainer}>
                {metas.map((meta, idx) => (
                    <React.Fragment key={idx}>
                        {idx > 0 && (
                            <div className={styles.sectionDivider} />
                        )}
                        <FilteredConnectionsSection
                            key={idx}
                            meta={meta}
                            isSelectMode={true}
                            selectedIds={selectedIds}
                            onToggle={onToggle}
                            onConnectionsFetched={onFetchedConnectionsChange}
                            openSection={idx === 0} // SCHOOL section open by default
                            placementType={ConnectionPlacementType.OVERLAY_LIST}
                        />
                    </React.Fragment>
                ))}
            </div>
            <div className={styles.sectionDivider} />
        </div>
    );
};

export default ManualListPlacementPage;
